"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var const_1 = require("./const");
var createTableRowPlugin = function (props) {
    var TableRowItem = /** @class */ (function (_super) {
        __extends(TableRowItem, _super);
        function TableRowItem() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = const_1.NODE_NAME.TABLE_ROW;
            _this.content = "(table_cell" + (props.useTableHeader ? ' | table_header' : '') + ")*";
            _this.tableRole = 'row';
            _this.parseDOM = [{ tag: 'tr' }];
            _this.toDOM = function () {
                return ['tr', 0];
            };
            return _this;
        }
        return TableRowItem;
    }(core_utilities_1.Block));
    return /** @class */ (function (_super) {
        __extends(TableRowPlugin, _super);
        function TableRowPlugin() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Schema = TableRowItem;
            return _this;
        }
        return TableRowPlugin;
    }(core_utilities_1.SylPlugin));
};
exports.createTableRowPlugin = createTableRowPlugin;
//# sourceMappingURL=table-row.js.map